<div class="container-fluid">
  <div class="page-header">
    <h1>{{translate.instant('pages.notFoundMsg')}}</h1>
  </div>
</div>
